/* eslint-disable @atlassian/tangerine/import/no-restricted-paths */
import urlTemplate from 'url-template';
import { EngagekitChoreographerPlugin } from '@atlassian/ipm-choreographer';
import { NO_CONTENT } from '../../controllers/coordination/utils/status-codes';
import { errorIfNotOk, pullResponseTextIfNotOk, stargateFetchRetryOn5xx } from '../fetch-utils';
export const TARGETING_SCHEMA_VERSION = '2';
const inProductMessagesUrlTemplate = urlTemplate.parse('/engage-targeting/api/v2/user/{cloudId}/in-product-messages{?product,schema,locale}');
export async function getMessages(cloudId, stargateUrl, product, locale) {
  return stargateFetchRetryOn5xx(`${stargateUrl}${inProductMessagesUrlTemplate.expand({
    cloudId,
    product,
    schema: TARGETING_SCHEMA_VERSION,
    locale
  })}`).then(errorIfNotOk).then(r => r.json().then(messages => ({
    messages,
    interval: Number.parseFloat(r.headers.get('POLL-INTERVAL') || '0')
  })));
}
function handleStartStopMessageResponse(response) {
  return response.status === NO_CONTENT;
}
const startMessageUrlTemplate = urlTemplate.parse('/engage-targeting/api/v2/user/messages/{messageId}/start');
const startMessageWithVariationIdUrlTemplate = urlTemplate.parse('/engage-targeting/api/v2/user/messages/{messageId}/start/{variationId}');
const stopMessageUrlTemplate = urlTemplate.parse('/engage-targeting/api/v2/user/messages/{messageId}/stop');
// Initialize the choreographer plugin on module load
const choreographerPlugin = new EngagekitChoreographerPlugin();
export async function startMessage(startMessageConfig, options) {
  if (options !== null && options !== void 0 && options.enableChoreographer) {
    return startMessageWithChoreographer(startMessageConfig);
  }
  return startMessageWithCoordination(startMessageConfig);
}
export async function stopMessage(stopMessageConfig, options) {
  if (options !== null && options !== void 0 && options.enableChoreographer) {
    return stopMessageWithChoreographer(stopMessageConfig);
  }
  return stopMessageWithCoordination(stopMessageConfig);
}
async function startMessageWithChoreographer(startMessageConfig) {
  return choreographerPlugin.startMessageWithPlugin(startMessageConfig.messageId, () => startMessageWithCoordination(startMessageConfig));
}
async function stopMessageWithChoreographer(stopMessageConfig) {
  return choreographerPlugin.stopMessageWithPlugin(stopMessageConfig.messageId, () => stopMessageWithCoordination(stopMessageConfig));
}
async function startMessageWithCoordination(startMessageConfig) {
  const requestBody = {
    cloudId: startMessageConfig.cloudId,
    orgId: startMessageConfig.orgId,
    workspaceId: startMessageConfig.workspaceId
  };
  return stargateFetchRetryOn5xx(startMessageConfig.variationId ? `${startMessageConfig.stargateUrl}${startMessageWithVariationIdUrlTemplate.expand({
    messageId: startMessageConfig.messageId,
    variationId: startMessageConfig.variationId
  })}` : `${startMessageConfig.stargateUrl}${startMessageUrlTemplate.expand({
    messageId: startMessageConfig.messageId
  })}`, {
    method: 'post',
    body: JSON.stringify(requestBody),
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(pullResponseTextIfNotOk).then(handleStartStopMessageResponse);
}
async function stopMessageWithCoordination(stopMessageConfig) {
  const requestBody = {
    cloudId: stopMessageConfig.cloudId,
    orgId: stopMessageConfig.orgId,
    workspaceId: stopMessageConfig.workspaceId
  };
  return stargateFetchRetryOn5xx(`${stopMessageConfig.stargateUrl}${stopMessageUrlTemplate.expand({
    messageId: stopMessageConfig.messageId
  })}`, {
    method: 'post',
    body: JSON.stringify(requestBody),
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(pullResponseTextIfNotOk).then(handleStartStopMessageResponse);
}
const userResponseUrlTemplate = urlTemplate.parse('/engage-targeting/api/v2/user/{cloudId}/messages/{messageId}/response');
export async function sendUserResponse(cloudId, stargateUrl, messageId, payload) {
  return stargateFetchRetryOn5xx(`${stargateUrl}${userResponseUrlTemplate.expand({
    cloudId,
    messageId
  })}`, {
    method: 'post',
    body: JSON.stringify(payload),
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(pullResponseTextIfNotOk).then(() => Promise.resolve());
}
const markSeenAndFatigueUrlTemplate = urlTemplate.parse('/engage-targeting/api/v2/user/messages/{messageId}/seen');
export async function markAsSeenAndFatigued(seenMessageConfig) {
  const requestBody = {
    cloudId: seenMessageConfig.cloudId,
    orgId: seenMessageConfig.orgId,
    workspaceId: seenMessageConfig.workspaceId
  };
  return stargateFetchRetryOn5xx(`${seenMessageConfig.stargateUrl}${markSeenAndFatigueUrlTemplate.expand({
    messageId: seenMessageConfig.messageId
  })}`, {
    method: 'post',
    body: JSON.stringify(requestBody),
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(pullResponseTextIfNotOk).then(() => Promise.resolve());
}